import { Icon } from '../../../../common/html/icon'
import { UseScoreRange } from '../../common/hooks/useScoreRange'
import { VALUE_SCORE } from '../../constant'

const getNameScoreRange = (data) => {
  const {
    scoreRange_Min: min,
    scoreRange_Max: max,
    scoreRangeName,
  } = data || {}
  if (min == null || max == null) return scoreRangeName
  return min
    ? `${scoreRangeName} (${min}-${max})`
    : Number(0) === 0
    ? `${scoreRangeName} (0)`
    : `${scoreRangeName}`
}

const getColorScoreRange = (data) => data?.color

export const LevelName = ({ val, typeValue }) => {
  const { creditRangeById, perRangeById } = UseScoreRange(true, 0, val)

  const name = getNameScoreRange(
    typeValue === VALUE_SCORE.CREDIT_SCORE ? creditRangeById : perRangeById,
  )

  const color =
    getColorScoreRange(
      typeValue === VALUE_SCORE.CREDIT_SCORE ? creditRangeById : perRangeById,
    ) || '#9c9c9c'

  return (
    <>
      <div className="dFlex alignItemsCenter gap1">
        <Icon
          className="icon-square cursorDefault"
          style={{ fontSize: 13, color: color }}
        />
        {name}
      </div>
    </>
  )
}
